import {Component, OnInit}                     from '@angular/core';
import {NavController, ModalController}        from '@ionic/angular';
import {SessionService}                        from '../services/session.service';
import {Roles}                                 from '../enums/enums';
import {EditUserPage}                          from '../edit-user/edit-user.page';
import {EditContractPage}                      from '../edit-contract/edit-contract.page';
import {EditBonusPage}                         from '../edit-bonus/edit-bonus.page';
import {Router}                                from '@angular/router';
import {ActivatedRoute}                        from '@angular/router';
import {DataStore}                             from '@aws-amplify/datastore';
import {User, Team, Contract, Bonus, S3Object} from '../../models';
import {ImgModalComponentComponent}            from "../modals/img-modal-component/img-modal-component.component";
import {ModalService}                          from "../services/modal.service";

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.page.html',
    styleUrls: ['./my-profile.page.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class MyProfilePage implements OnInit {
    userId;

    currentUser: User;
    profile = 'personal';
    clientFullName = '';
    assignedToFullName = '';
    addedByFullName = '';
    contractsList: any[];
    bonusList: any[];
    teamName = '';
    user = null;
    roles = Roles;
    pageTitle = 'My Profile';

    constructor(
            private route: ActivatedRoute,
            private modalService: ModalService,
            private navController: NavController,
            private modalController: ModalController,
            public router: Router,
            public sessionService: SessionService,
    ) {
    }

    async ngOnInit() {
        const currentUser = this.sessionService.getCurrentUser();
        
        if (!this.userId)
            this.userId = currentUser?.id;

        this.currentUser = await DataStore.query(User, this.userId);
        
        // defaults to Client's contract
        let queryFilter = c => c.client?.id == this.userId;
        if (this.currentUser?.role != Roles.CLIENT.displayName) queryFilter = c => c.userContractsAddedId == this.userId;
        this.contractsList = (await DataStore.query(Contract)).filter(queryFilter);
        

        // Make sure we update the page title based on the user profile we're looking at
        if (this.currentUser?.id != currentUser?.id) {
            this.pageTitle = `${this.currentUser?.name} ${this.currentUser?.lastname} Profile`;
        }

        // Load bonus if not client
        this.bonusList = (await DataStore.query(Bonus)).filter(b =>
                        b.user?.id == this.userId
                //    b.userBonusId == this.userId
        );
        

        // @todo let's see if a custom resolver in the backend let me fetch all related user details for a single user
        this.renderModelNamesById();
    }

    ionViewDidEnter() {
        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    async edit() {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: this.currentUser?.id},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshProfile();
        });
    }

    openContract(contractId: string) {
        this.router.navigate(['/contract', contractId]);
    }

    editContract(contractId: string) {
        this.openEditContractModal(contractId);
    }

    addContract() {
        this.openEditContractModal(null);
    }

    private async openEditContractModal(contractId: any) {
        this.modalService.contractEdit(contractId).then(d => {
            this.refreshContractsList();

        });
    }

    async deleteContract(contractId: string) {
        if (confirm('Do you want to delete this Contract')) {
            await DataStore.delete(Contract, contractId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshContractsList();
            }, 1000);
        }
    }

    refreshContractsList() {

    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    openBonus(bonusId: string) {
        this.router.navigate(['/bonus', bonusId]);
    }

    editBonus(bonusId: string) {
        this.openEditBonustModal(bonusId);
    }

    private async openEditBonustModal(bonusId: any) {
        const modal = await this.modalController.create({
            component: EditBonusPage,
            componentProps: {bonusId: bonusId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            // this.refreshContractsList();
        });
    }

    async deleteBonus(bonusId: string) {
        if (confirm('Do you want to delete this Bonus')) {
            await DataStore.delete(Bonus, bonusId);
            // let the animation finish its job
            setTimeout(() => {
                // this.refreshContractsList();
            }, 1000);
        }
    }


    back() {
        this.navController.back();
    }

    private async refreshProfile() {
        this.currentUser = await DataStore.query(User, this.currentUser?.id);
        this.renderModelNamesById();
    }

    private async renderModelNamesById() {
        if (this.currentUser?.teamID) {
            const team = await DataStore.query(Team, this.currentUser?.teamID);
            this.teamName = team.name;
        }
        if (this.currentUser?.assignedTo) {
            const assignedToUser = await DataStore.query(User, this.currentUser?.assignedTo);
            this.assignedToFullName = `${assignedToUser.name} ${assignedToUser.lastname}`;
        }
        if (this.currentUser?.addedBy) {
            const addedByUser = await DataStore.query(User, this.currentUser?.addedBy);
            this.addedByFullName = `${addedByUser.name} ${addedByUser.lastname}`;
        }
    }


    async signout($e) {
        
        this.sessionService.signout();

        //  await  this.router.navigate(['/login']);
    }

    showFoto() {
        
    }

    async openImageModal(profileImg: S3Object | undefined) {
        const modal = await this.modalController.create({
            component: ImgModalComponentComponent,
            componentProps: {img: profileImg},
            showBackdrop: true,
            mode: "ios",
            animated: true,


        });
        await modal.present();
    }
}
